var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","text-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.userIsStudent())?_c('student-settings'):_vm._e(),(_vm.userIsProfessor())?_c('professor-settings'):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }